import styled from "styled-components";

export const JoinTypeSelect = styled.ul`
  gap: 6px;
  width: calc(100vw - 32px);
  display: grid;
  margin-top: 20px;
  grid-template-columns: repeat(2, calc(50vw - 19px));
`;
